import styled from 'styled-components'

export const FieldContainer = styled.div`
  margin-bottom: 1rem;
`
